var app;
(function (app) {
    var tarefas;
    (function (tarefas) {
        var minhasTarefas;
        (function (minhasTarefas) {
            var AssignTagController = /** @class */ (function () {
                /** @ngInject **/
                function AssignTagController($mdDialog, minhasTarefasService, tasks, tags) {
                    this.$mdDialog = $mdDialog;
                    this.minhasTarefasService = minhasTarefasService;
                    this.tasks = tasks;
                    this.tags = tags;
                    this.cmd = new minhasTarefas.AssigneeTagTasksCommand(tasks);
                }
                AssignTagController.prototype.addtagsTasks = function () {
                    var _this = this;
                    this.minhasTarefasService.setTagsTasks(this.cmd)
                        .then(function () {
                        _this.tasks.forEach(function (task) {
                            var _a;
                            if (task.etags != null) {
                                (_a = task.etags).push.apply(_a, _this.cmd.tags);
                            }
                            else {
                                task.etags = _this.cmd.tags;
                            }
                        });
                        _this.$mdDialog.hide();
                    });
                };
                AssignTagController.prototype.closeDialog = function () {
                    this.$mdDialog.hide();
                };
                return AssignTagController;
            }());
            minhasTarefas.AssignTagController = AssignTagController;
            angular
                .module("app.tarefas.minhas-tarefas")
                .controller("app.tarefas.minhas-tarefas.AssignTagController", AssignTagController);
        })(minhasTarefas = tarefas.minhasTarefas || (tarefas.minhasTarefas = {}));
    })(tarefas = app.tarefas || (app.tarefas = {}));
})(app || (app = {}));
